import React, { createContext, useReducer } from 'react'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'header': {
      return { ...data, ...payload.data, loader: {}, notification: {} }
    }
    case 'notification': {
      return { ...data, notification: payload.data, loader: {} }
    }
    case 'loader': {
      return {
        ...data,
        loader: payload.data,
        notification: payload.notification,
      }
    }
    case 'permissions': {
      return {
        ...data,
        permissions: payload.data,
        make: payload.make,
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  header: null,
  sub_header: null,
  show_back_btn: true,
  notification: {},
  loader: {},
  permissions: [],
  make: null,
  show_home_button: false,
}

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <NavContext.Provider value={[state, dispatch]}>
      {children}
    </NavContext.Provider>
  )
}

export const NavContext = createContext(initialState)
export default Store
